import { useMutation } from "react-query";

import { buildFormDataPayload } from "../../helpers/api";
import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehicleSourcingOption } from "../../types/Dossier";

type VehicleSourcingOptionPayload = {
  vehicleSourcingOption: VehicleSourcingOption;
  vehiclePricingFile: File | null;
};

export const chooseDossierVehicleSourcingOption = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: VehicleSourcingOptionPayload): Promise<string> => {
      return fetchWithAuth<string>(
        "chooseDossierVehicleSourcingOption",
        dossierId,
        {
          requestOptions: {
            method: "post",
            body: buildFormDataPayload(payload, ["vehiclePricingFile"]),
            excludeContentTypeHeader: true,
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled([["dossier", dossierId]]),
  });
};
